const APP_VERSION = process.env.REACT_APP_VERSION;

// Quiet footer that sits on the page background, aligned with page content
const FooterAdmin = () => (
  <footer className="border-t border-hcBorder px-4 py-5 sm:px-7">
    <div className="flex flex-col gap-1.5 text-xs text-hcMuted sm:flex-row sm:items-center sm:justify-between">
      <p>&copy; {new Date().getFullYear()} HoneConnect. All rights reserved.</p>
      <p className="flex items-center gap-2">
        <span>Admin console</span>
        {APP_VERSION && (
          <>
            <span aria-hidden className="h-1 w-1 rounded-full bg-gray-300" />
            <span>Version {APP_VERSION}</span>
          </>
        )}
      </p>
    </div>
  </footer>
);

export default FooterAdmin;
